import { API } from '@imprint-payments/types';

import { ApiRequestV2, httpRequestV2 } from '../http/client';
import { HEADERS, Method } from '../http/httpConsts';

export interface GetPrefillDataArgs {
  ssn4: string;
  sessionId: string;
  productUUID: string;
}

export type GetPrefillDataResponse = API.Response<
  '/v1/consumer/prefill',
  'post'
>;

export const getPrefillData = async ({
  ssn4,
  sessionId,
  productUUID,
}: GetPrefillDataArgs): Promise<GetPrefillDataResponse> => {
  const req: ApiRequestV2 = {
    path: '/v1/consumer/prefill',
    method: Method.POST,
    headers: {
      [HEADERS.productUUID]: productUUID,
    },
    body: {
      ssn4,
      sessionId,
    },
  };

  return httpRequestV2(req);
};
